import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Play } from 'lucide-react';
import { heroData } from '../data/mock';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroData.heroImage}
          alt="Construction"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a]/95 via-[#0f172a]/80 to-[#0f172a]/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center lg:text-left">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-[#d4af37]/10 border border-[#d4af37]/30 rounded-full mb-6 backdrop-blur-sm">
            <span className="text-[#d4af37] font-semibold text-sm">
              {heroData.subtitle}
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {heroData.title.split(',')[0]},
            <br />
            <span className="text-[#d4af37]">{heroData.title.split(',')[1]}</span>
          </h1>

          {/* Description */}
          <p className="text-xl text-gray-300 mb-10 leading-relaxed max-w-2xl">
            {heroData.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-[#d4af37] text-[#0f172a] hover:bg-[#c4a137] font-semibold px-8 py-6 text-lg transition-all duration-200 hover:scale-105 group"
            >
              {heroData.ctaText}
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button 
              onClick={() => scrollToSection('portfolio')}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#0f172a] font-semibold px-8 py-6 text-lg transition-all duration-200 group"
            >
              <Play className="mr-2 group-hover:scale-110 transition-transform" size={20} />
              {heroData.ctaSecondary}
            </Button>
          </div>

          {/* Stats Bar */}
          <div className="mt-16 grid grid-cols-3 gap-8 pt-8 border-t border-gray-600/30">
            <div>
              <div className="text-3xl font-bold text-[#d4af37]">500+</div>
              <div className="text-gray-400 text-sm mt-1">Projects</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-[#d4af37]">25+</div>
              <div className="text-gray-400 text-sm mt-1">Years</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-[#d4af37]">98%</div>
              <div className="text-gray-400 text-sm mt-1">Satisfaction</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-[#d4af37] rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
